<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="800px"
  >
    <confirm-dialog
      v-model="isConfirmRefuseDialogOpened"
      @no="isConfirmRefuseDialogOpened = false"
      @yes="refuse"
    />
    <v-card v-if="hasInboxIntervention">
      <v-card-title>
        Inbox - Intervention récurrente
        <v-spacer></v-spacer>
        <v-btn icon @click="isOpened = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0" v-if="isOpened">
        <v-row
          no-gutters
          justify="center"
          align="center"
          class="recurrent-intervention-recurrence px-4 py-2"
        >
          <v-icon class="mr-1">play_arrow</v-icon>
          <div class="font-weight-medium">
            Proposée le {{ inboxIntervention.createdAt | formatDate }}
          </div>
          <v-spacer />
        </v-row>
        <div class="pa-4">
          <v-row no-gutters justify="center" align="center">
            <v-col>
              <v-text-field
                v-model="inboxIntervention.client.name"
                readonly
                label="Client"
                hide-details
                outlined
                class="mr-2"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="inboxIntervention.site.name"
                readonly
                label="Site"
                hide-details
                outlined
                class="mr-2"
              />
            </v-col>
          </v-row>
          <v-text-field
            v-model="inboxIntervention.title"
            readonly
            label="Titre de l'intervention"
            placeholder="Titre de l'intervention"
            persistent-placeholder
            hide-details
            outlined
            class="mt-4"
          />
          <v-textarea
            v-model="inboxIntervention.description"
            readonly
            no-resize
            label="Description"
            placeholder="Aucune description détaillée"
            persistent-placeholder
            hide-details
            outlined
            height="200"
            class="mt-4"
          />
          <v-row no-gutters justify="center" align="center" class="mt-4">
            <v-col>
              <v-text-field
                v-model="inboxIntervention.priority.name"
                readonly
                label="Priorité"
                hide-details
                outlined
                class="mr-2"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="inboxIntervention.domain.name"
                readonly
                label="Domaine"
                hide-details
                outlined
                class="mr-2"
              />
            </v-col>
          </v-row>
          <div class="pt-6">
            <h3 class="pl-1">Équipements concernés</h3>
            <div class="pl-1" v-if="!inboxIntervention.equipments.length">
              <i>Aucun équipement ajouté</i>
            </div>
            <n-card class="form-attachment px-3 mt-2" v-for="equipment in inboxIntervention.equipments" :key="`equipment-${equipment.id}`">
              <div class="py-2">
                <v-row no-gutters align="center">
                  <v-icon color="primary" class="mr-2">memory</v-icon>
                  <v-col style="font-size: 15px;">
                    {{ equipment.label }}
                  </v-col>
                </v-row>
              </div>
            </n-card>
          </div>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-3 px-4">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!$canWrite"
          type="submit"
          color="error"
          :loading="isLoading"
          class="mr-2 pr-4"
          @click="$canWrite && (isConfirmRefuseDialogOpened = true)"
        >
          <v-icon left>clear</v-icon>
          Refuser
        </v-btn>
        <v-btn
          :disabled="!$canWrite"
          type="submit"
          color="success"
          :loading="isLoading"
          class="pr-4"
          @click="$canWrite && (accept($event))"
        >
          <v-icon left>done</v-icon>
          Ajuster et créer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
// import { mapActions } from 'vuex';

export default {
  data: () => ({
    isConfirmRefuseDialogOpened: false,
    isLoading: false,
  }),

  props: {
    value: Boolean,
    inboxIntervention: {
      type: Object,
      required: false,
    },
  },

  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) {
        return this.$emit(`input`, isOpened);
      },
    },
    hasInboxIntervention() {
      return Boolean(this.inboxIntervention && this.inboxIntervention.id);
    },
  },

  methods: {
    ...mapActions(`model/inboxIntervention`, [
      `markRefused`,
    ]),
    accept() {
      this.$store.commit(`ui/newIntervention/SET_CLIENT`, this.inboxIntervention.client);
      this.$store.commit(`ui/newIntervention/SET_SITE`, this.inboxIntervention.site);
      this.$store.commit(`ui/newIntervention/SET_TITLE`, this.inboxIntervention.title);
      this.$store.commit(`ui/newIntervention/SET_DESCRIPTION`, this.inboxIntervention.description || ``);
      this.$store.commit(`ui/newIntervention/SET_PRIORITY`, this.inboxIntervention.priority);
      this.$store.commit(`ui/newIntervention/SET_DOMAIN`, this.inboxIntervention.domain);
      this.$store.commit(`ui/newIntervention/SET_EQUIPMENTS`, this.inboxIntervention.equipments || []);
      this.$store.commit(`ui/newIntervention/SET_INBOX_INTERVENTION`, this.inboxIntervention);
      this.$router.push({
        path: `/tickets/new`,
        query: { fromInbox: 1 },
      });
    },
    async refuse() {
      this.isLoading = true;
      await this.markRefused(this.inboxIntervention.id);
      this.$emit(`refused`);
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.recurrent-intervention-recurrence {
  background-color: #e7e8ff;
}
</style>
